<template>
  <div class="video-skeleton">
    <div class="skeleton-grid">
      <div 
        v-for="i in 6" 
        :key="i" 
        class="skeleton-card"
      >
        <div class="skeleton-cover"></div>
        <div class="skeleton-info">
          <div class="skeleton-title"></div>
          <div class="skeleton-count"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoSkeleton'
}
</script>

<style lang="less" scoped>
.video-skeleton {
  padding: 8px 0;
}

.skeleton-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.skeleton-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.skeleton-cover {
  width: 100%;
  aspect-ratio: 16/9;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

.skeleton-info {
  padding: 12px;
  
  .skeleton-title {
    height: 16px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    border-radius: 4px;
    margin-bottom: 8px;
  }
  
  .skeleton-count {
    height: 12px;
    width: 60%;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    border-radius: 4px;
  }
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* 响应式 */
@media (max-width: 375px) {
  .skeleton-grid {
    gap: 10px;
  }
}

@media (min-width: 768px) {
  .skeleton-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }
}

@media (min-width: 1024px) {
  .skeleton-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
}

/* 深色模式 */
@media (prefers-color-scheme: dark) {
  .skeleton-card {
    background: #2d3748;
  }
  
  .skeleton-cover,
  .skeleton-title,
  .skeleton-count {
    background: linear-gradient(90deg, #4a5568 25%, #718096 50%, #4a5568 75%);
    background-size: 200% 100%;
  }
}

/* 减少动画 */
@media (prefers-reduced-motion: reduce) {
  .skeleton-cover,
  .skeleton-title,
  .skeleton-count {
    animation: none;
    background: #f0f0f0;
  }
}
</style>